import { SalesAgreementContextProvider } from '@features/TimberBuyer/SalesAgreements/SalesAgreementContext'
import { getSalesAgreementQuery } from '@services/queryOptions'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Outlet } from '@tanstack/react-router'

const SalesAgreementLayout: React.FC = () => {
  const { timberBuyerId, salesAgreementId } = Route.useParams()
  const { data, isLoading, isError, refetch } = useQuery(
    getSalesAgreementQuery(timberBuyerId, salesAgreementId),
  )

  const handleRefetch = () => {
    void refetch()
  }

  return (
    <SalesAgreementContextProvider value={{ data, isLoading, isError, refetch: handleRefetch }}>
      <Outlet />
    </SalesAgreementContextProvider>
  )
}

export const Route = createFileRoute(
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId',
)({
  component: SalesAgreementLayout,
})
